import { useQuery } from '@tanstack/react-query';
import etfPriceService from "@etfPriceService";

export function useFetchETFPriceHistory(tickerSymbol: string, timePeriod: TimeRange = 'ALL') {
  return useQuery({
    queryKey: ['etf_price_history', tickerSymbol, timePeriod],
    queryFn: async () => {
      return await etfPriceService.fetchETFPriceHistory({ tickerSymbol, timePeriod });
    },
    enabled: !!tickerSymbol,
  });
}


/** Fetches price history for multiple tickers in a single query. */
export function useMultiTickerPriceHistory(tickers: string[], timePeriod: TimeRange) {
  return useQuery({
    queryKey: ['etf_price_history_multi', tickers, timePeriod],
    queryFn: async () => {
      return await etfPriceService.fetchMultiTickerPriceHistory({ tickers, timePeriod})
    },
    enabled: tickers.length > 0,
  });
}
